<div *ngIf="errormessage==false"class="mydownline">
    <div class="body-title no-margin ">
        <div class="row" *ngIf="selectedCountry">
            <div class="col-sm-3 col-xs-12 text-left report-username downline-font">
                <b>{{userName | titleCase}} </b>({{distributorId | numberformat}})</div>
            <!-- <div class="col-sm-6 col-xs-12 text-center report-heading">{{'mydownline.MyDownline Volume' |translate |translateKey }}</div> -->
            <div [class.hide]="selectedCountry && selectedCountry.name == undefined " class="col-sm-6 col-xs-12 text-center report-heading">{{'customer-service.MyDownline Volume' |translate |translateKey}}
                <!-- <span class="mytooltip ico-help fa fa-info-circle" style="font-size:15px"> -->
               <!-- <span class="tooltiptext" >{{"mydownline.My downline volume report Provides the FBO downline and their monthly and yearly CC details for the home country" |translate |translateKey}}</span>
                     </span> -->
                     <span style="font-size:15px" title="{{'customer-service.My downline volume report Provides the FBO downline and their monthly and yearly CC details for the home country' |translate}}"
                        class="ico-help fa fa-question-circle"></span>
                     - {{selectedCountry.name}}</div>
            <div [class.hide]="selectedCountry && selectedCountry.name != undefined " class="col-sm-6 col-xs-12 text-center report-heading">{{'customer-service.MyDownline Volume' |translate |translateKey}}</div>

            <div class="col-sm-3 col-xs-12 text-right report-rundate downline-font">
                <b>{{'customer-service.Run Date:' |translate |translateKey}} </b> {{mydate}}</div>
        </div>
    </div>
    <br/>
    <div class="row profile">
        <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 no-padding">
            <div id="filter" class="form-group col-xs-12 col-sm-4 col-lg-2 col-md-3">
                <label for="country" class="label-font">{{'customer-service.Select Country' |translate |translateKey }}
                    <!-- <span class="mytooltip ico-help fa fa-question-circle">
                        <span class="tooltiptext">{{'common.Select Country' |translate |translateKey }}</span>
                    </span> -->
                    <span title="{{'customer-service.Select Country' |translate}}"
                                                class="ico-help fa fa-question-circle"></span>
                </label>

                <select [(ngModel)]="selectedCountry" tabindex="0" class="form-control" title="Select Country" (change)=(changeCountry(selectedCountry.value))>
                    <option *ngFor="let country of countries | orderBy:'name'" [ngValue]="country"> {{country.name}} </option>
                </select>
            </div>

            <div id="btn-expand" class="col-xs-8 col-sm-4 col-md-4 col-lg-3">
                <button type="button" (click)="expandNextLevel()" class="btn btn-small btn-buttom blue-button">{{'customer-service.Expand Further Downline' |translate |translateKey }}</button>
            </div>

            <div class="col-xs-12 col-sm-12 col-md-5 col-lg-6 checkbox pad-top">
                <label>
                    <input type="checkbox" tabindex="0" (click)="getDownlineDetailsByHideZeroPersonalCC()" value="">{{'customer-service.Hide Forever Business Owners with zero Personal CC in selected month' |translate |translateKey}}
                </label>
            </div>
        </div>


        <div class="profile-content no-padding col-md-12 margin-left">
            <div class="col-md-4 col-sm-4 col-lg-2 col-xs-12">
                <!-- <div class="form-group"> -->
                <label for="yearfilter" class="label-font">{{'customer-service.Select Year' |translate |translateKey }}
                    <!-- <span class="mytooltip ico-help fa fa-question-circle">
                        <span class="tooltiptext">{{'mydownline.Select required year' |translate |translateKey }}</span>
                    </span> -->
                    <span title="{{'customer-service.Select required year' |translate}}"
                    class="ico-help fa fa-question-circle"></span>
                </label>
                <select #yearFilter tabindex="0" name="yearfilter" class="form-control" (change)="setYear(yearFilter.value)">
                    <option value="0">{{'customer-service.Select' |translate |translateKey }}</option>
                    <option *ngFor="let year of recentYears" [value]="year"> {{year}} </option>
                </select>
                <!-- </div> -->
            </div>

            <div class="col-md-4 col-sm-4 col-lg-2 col-xs-12">
                <div class="form-group">
                    <label for="monthfilter" class="label-font">{{'customer-service.Select Month' |translate |translateKey }}
                        <!-- <span class=" mytooltip ico-help fa fa-question-circle ">
                            <span class="tooltiptext">{{'mydownline.Select required month' |translate |translateKey }} </span>
                        </span> -->
                        <span title="{{'customer-service.Select required month' |translate}}"
                        class="ico-help fa fa-question-circle"></span>
                    </label>
                    <select tabindex="0" name="monthfilter" id="monthfilter" [disabled]="year === 0" tabindex="3" #monthFilter class="form-control" title="Month Filter"
                        (change)="setMonth(monthFilter.value)">
                        <option value="0">{{'customer-service.Select' |translate |translateKey }}</option>
                        <option *ngFor="let month of monthValues" [value]="month.id">{{month.itemName}}</option>
                    </select>
                    <span [hidden]="monthFlag === false" id="alert-text">Selected month cannot be more than current month </span>
                </div>

            </div>


            <div class="col-md-4 col-xs-12 col-sm-4 col-lg-2">
                <div class="form-group">
                    <label for="levelfilter" class="label-font">{{'customer-service.Select Level' |translate |translateKey }}
                        <!-- <span class="mytooltip ico-help fa fa-question-circle">
                            <span class="tooltiptext">{{'mydownline.Select levels to filter FBOs based on level' |translate |translateKey }}</span>
                        </span> -->
                        <span title="{{'customer-service.Select levels to filter FBOs based on level' |translate}}"
                        class="ico-help fa fa-question-circle"></span>
                    </label>
                    <angular2-multiselect id="dropdown" tabindex="0" [data]="fboLevels" [(ngModel)]="selectedLevels" [settings]="multiSelectSetting"
                        (onSelect)="onItemSelect($event)" (onDeSelect)="OnItemDeSelect($event)" (onSelectAll)="onSelectAll($event)"
                        (onDeSelectAll)="onDeSelectAll($event)">
                    </angular2-multiselect>
                </div>
            </div>

            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                <div>
                    <label class="label-font">{{'customer-service.Forever Business Owner' |translate |translateKey }}
                        <!-- <span class=" mytooltip ico-help fa fa-question-circle">
                            <span class="tooltiptext"> {{'mydownline.Enter FBOID to retrieve particular FBO downline details' |translate |translateKey
                                }} </span>
                        </span> -->
                        <span title="{{'customer-service.Enter FBOID to retrieve particular FBO downline details' |translate}}"
                        class="ico-help fa fa-question-circle"></span>
                    </label>
                    <input type="text" tabindex="0" id="businessownerid" [(ngModel)]="ownerIdorName" title="Forever Business Owner" class="form-control"
                    />
                </div>
            </div>

            <div id="btn-pad" class="col-xs-3 col-sm-2 col-md-2 col-lg-1">
                <button type="button" tabindex="0" (click)="getDownlineByFilters()" class="btn btn-small btn-buttom btn-success">{{'customer-service.Apply' |translate |translateKey }}</button>
            </div>

            <div class="col-xs-9 col-sm-4 col-md-6 col-lg-2 text-right" id="export">
                <label class="export-label label-font">{{'customer-service.Export :' |translate |translateKey}}</label>
                <div class="export-buttons pull-right">
                    <img  class="card-image" id="excelimage" (click)="downloadExcel()" title="{{'customer-service.Export excel' |translate |translateKey}}"
                        width="35px" height="36px"  [src]="excelImageUrl"  alt="..."  />
                </div>
            </div>

        </div>

    </div>
</div>

<div class="table-style ">
    <div class="table-layout">
        <table id="mydownlinevolume" width="100%" class="table-responsive table-condensed table-hover treetable"
            cellspacing="0" width="100%">
            <thead style="white-space: nowrap;">
                <tr>
                    <th colspan="6"></th>
                    <th colspan="3" class="text-center">{{'customer-service.Active' |translate |translateKey }}</th>
                    <th colspan="3" class="text-center">{{'customer-service.Personal CC' |translate |translateKey }}</th>
                    <th colspan="3" class="text-center">{{'customer-service.Retail CC' |translate |translateKey }}</th>
                    <th colspan="3" class="text-center">{{'customer-service.Total CC' |translate |translateKey }}</th>
                    <th colspan="1"> {{'customer-service.Total Global CC' |translate |translateKey }} </th>
                    <th colspan="4" class="text-center">{{'customer-service.Total Active CC' |translate |translateKey }}</th>
                    <th colspan="4" class="text-center">{{'customer-service.Non-Manager CC' |translate |translateKey }}</th>
                    <th colspan="4" class="text-center">{{'customer-service.Leadership CC' |translate |translateKey }}</th>
                    <th colspan="" class="text-center">{{'customer-service.New Eagle Manager' |translate |translateKey }}</th>
                    <th colspan="" class="text-center">{{'customer-service.New Chairmans Bonus' |translate |translateKey }}</th>
                    <th colspan="2"></th>
                </tr>
                <tr>
                    <th> {{'customer-service.Name' |translate |translateKey }}
                        <span [ngClass]="{'fa-sort':(sortOption !== 'name' || sortOption !== 'name'),'fa-sort-desc':sortOption === 'name','fa-sort-asc':sortOption === 'name'}"
                            class="fa" id="sort" tabindex="0" (keyup.enter)="getDownlineDetailsBySortOption('name')" (click)="getDownlineDetailsBySortOption('name')">
                        </span>
                    </th>
                    <th>{{'customer-service.Generation' |translate |translateKey }}
                        <span [ngClass]="{'fa-sort':(sortOption !== 'gen' || sortOption !== 'gen'),'fa-sort-desc':sortOption === 'gen','fa-sort-asc':sortOption === 'gen'}"
                            class="fa" id="sort" tabindex="0" (keyup.enter)="getDownlineDetailsBySortOption('gen')" (click)="getDownlineDetailsBySortOption('gen')">
                        </span>
                    </th>
                    <th>{{'customer-service.FBOID' |translate |translateKey }}
                        <span [ngClass]="{'fa-sort':(sortOption !== 'distributorId' || sortOption !== 'distributorId'),'fa-sort-desc':sortOption === 'distributorId','fa-sort-asc':sortOption === 'distributorId'}"
                            class="fa" id="sort" tabindex="0" (keyup.enter)="getDownlineDetailsBySortOption('distributorId')" (click)="getDownlineDetailsBySortOption('distributorId')">
                        </span>
                    </th>
                    <th>{{'customer-service.Title' |translate |translateKey }}
                        <span [ngClass]="{'fa-sort':(sortOption !== 'level' || sortOption !== 'level'),'fa-sort-desc':sortOption === 'level','fa-sort-asc':sortOption === 'level'}"
                            class="fa" id="sort" tabindex="0" (keyup.enter)="getDownlineDetailsBySortOption('level')" (click)="getDownlineDetailsBySortOption('level')">
                        </span>
                    </th>
                    <th>{{'customer-service.Country' |translate |translateKey }}
                        <span [ngClass]="{'fa-sort':(sortOption !== 'country' || sortOption !== 'country'),'fa-sort-desc':sortOption === 'country','fa-sort-asc':sortOption === 'country'}"
                            class="fa" id="sort" tabindex="0" (keyup.enter)="getDownlineDetailsBySortOption('country')" (click)="getDownlineDetailsBySortOption('country')">
                        </span>
                    </th>
                    <th>{{'customer-service.Sponsor Date' |translate |translateKey }}
                        <span [ngClass]="{'fa-sort':(sortOption !== 'sponsorDate' || sortOption !== 'sponsorDate'),'fa-sort-desc':sortOption === 'sponsorDate','fa-sort-asc':sortOption === 'sponsorDate'}"
                            class="fa" id="sort" tabindex="0" (keyup.enter)="getDownlineDetailsBySortOption('sponsorDate')" (click)="getDownlineDetailsBySortOption('sponsorDate')">
                        </span>
                    </th>
                    <th *ngFor="let month of recentMonths">{{'customer-service.'+ month |translate |translateKey}}</th>
                    <th *ngFor="let month of recentMonths">{{'customer-service.'+ month |translate |translateKey}}
                        <span [ngClass]="{'fa-sort':(sortOption !== 'personalCC_' + month || sortOption !== 'personalCC_' + month),'fa-sort-desc':sortOption === 'personalCC_' + month ,'fa-sort-asc':sortOption === 'personalCC_' + month}"
                            class="fa" id="sort" tabindex="0" (keyup.enter)="getDownlineDetailsBySortOption('personalCC_' + month)" (click)="getDownlineDetailsBySortOption('personalCC_' + month)">
                        </span>
                    </th>
                    <th *ngFor="let month of recentMonths">{{'customer-service.'+ month |translate |translateKey}}
                        <span [ngClass]="{'fa-sort':(sortOption !== 'retailCC' || sortOption !== 'retailCC'),'fa-sort-desc':sortOption === 'retailCC','fa-sort-asc':sortOption === 'retailCC'}"
                            class="fa" id="sort" tabindex="0" (keyup.enter)="getDownlineDetailsBySortOption('retailCC')" (click)="getDownlineDetailsBySortOption('retailCC')">
                        </span>
                    </th>
                    <th *ngFor="let month of recentMonths">{{'customer-service.'+ month |translate |translateKey}}
                        <span [ngClass]="{'fa-sort':(sortOption !== 'totalCC' || sortOption !== 'totalCC'),'fa-sort-desc':sortOption === 'totalCC','fa-sort-asc':sortOption === 'totalCC'}"
                            class="fa" id="sort"  tabindex="0" (keyup.enter)="getDownlineDetailsBySortOption('totalCC')" (click)="getDownlineDetailsBySortOption('totalCC')">
                        </span>
                    </th>
                    <th>{{'customer-service.YTD' |translate |translateKey }}
                        <span [ngClass]="{'fa-sort':(sortOption !== 'totalGlobalCCYTD' || sortOption !== 'totalGlobalCCYTD'),'fa-sort-desc':sortOption === 'totalGlobalCCYTD','fa-sort-asc':sortOption === 'totalGlobalCCYTD'}"
                            class="fa" id="sort" tabindex="0" (keyup.enter)="getDownlineDetailsBySortOption('totalGlobalCCYTD')" (click)="getDownlineDetailsBySortOption('totalGlobalCCYTD')">
                        </span>
                    </th>
                    <th *ngFor="let month of recentMonths">{{'customer-service.'+ month |translate |translateKey}}
                        <span [ngClass]="{'fa-sort':(sortOption !== 'totalActiveCC' || sortOption !== 'totalActiveCC'),'fa-sort-desc':sortOption === 'totalActiveCC','fa-sort-asc':sortOption === 'totalActiveCC'}"
                            class="fa" id="sort" tabindex="0" (keyup.enter)="getDownlineDetailsBySortOption('totalActiveCC')" (click)="getDownlineDetailsBySortOption('totalActiveCC')">
                        </span>
                    </th>
                    <th>{{'customer-service.YTD' |translate |translateKey }}
                        <span [ngClass]="{'fa-sort':(sortOption !== 'totalActiveCCYTD' || sortOption !== 'totalActiveCCYTD'),'fa-sort-desc':sortOption === 'totalActiveCCYTD','fa-sort-asc':sortOption === 'totalActiveCCYTD'}"
                            class="fa" id="sort" tabindex="0" (keyup.enter)="getDownlineDetailsBySortOption('totalActiveCCYTD')" (click)="getDownlineDetailsBySortOption('totalActiveCCYTD')">
                        </span>
                    </th>
                    <th *ngFor="let month of recentMonths">{{'customer-service.'+ month |translate |translateKey}}
                        <span [ngClass]="{'fa-sort':(sortOption !== 'nonManagerCC' || sortOption !== 'nonManagerCC'),'fa-sort-desc':sortOption === 'nonManagerCC','fa-sort-asc':sortOption === 'nonManagerCC'}"
                            class="fa" id="sort" tabindex="0" (keyup.enter)="getDownlineDetailsBySortOption('nonManagerCC')" (click)="getDownlineDetailsBySortOption('nonManagerCC')">
                        </span>
                    </th>
                    <th>{{'customer-service.YTD' |translate |translateKey }}
                        <span [ngClass]="{'fa-sort':(sortOption !== 'nonManagerCCYTD' || sortOption !== 'nonManagerCCYTD'),'fa-sort-desc':sortOption === 'nonManagerCCYTD','fa-sort-asc':sortOption === 'nonManagerCCYTD'}"
                            class="fa" id="sort" tabindex="0" (keyup.enter)="getDownlineDetailsBySortOption('nonManagerCCYTD')" (click)="getDownlineDetailsBySortOption('nonManagerCCYTD')">
                        </span>
                    </th>
                    <th *ngFor="let month of recentMonths">{{'customer-service.'+ month |translate |translateKey}}
                        <span [ngClass]="{'fa-sort':(sortOption !== 'leadershipCC' || sortOption !== 'leadershipCC'),'fa-sort-desc':sortOption === 'leadershipCC','fa-sort-asc':sortOption === 'leadershipCC'}"
                            class="fa" id="sort" tabindex="0" (keyup.enter)="getDownlineDetailsBySortOption('leadershipCC')" (click)="getDownlineDetailsBySortOption('leadershipCC')">
                        </span>
                    </th>
                    <th>{{'customer-service.YTD' |translate |translateKey }}
                        <span [ngClass]="{'fa-sort':(sortOption !== 'leadershipCCYTD' || sortOption !== 'leadershipCCYTD'),'fa-sort-desc':sortOption === 'leadershipCCYTD','fa-sort-asc':sortOption === 'leadershipCCYTD'}"
                            class="fa" id="sort" tabindex="0" (keyup.enter)="getDownlineDetailsBySortOption('leadershipCCYTD')" (click)="getDownlineDetailsBySortOption('leadershipCCYTD')">
                        </span>
                    </th>
                    <th>{{'customer-service.Global CC' |translate |translateKey }}
                        <span [ngClass]="{'fa-sort':(sortOption !== 'eagleManagerCC' || sortOption !== 'eagleManagerCC'),'fa-sort-desc':sortOption === 'eagleManagerCC','fa-sort-asc':sortOption === 'eagleManagerCC'}"
                            class="fa" id="sort" tabindex="0" (keyup.enter)="getDownlineDetailsBySortOption('eagleManagerCC')" (click)="getDownlineDetailsBySortOption('eagleManagerCC')">
                        </span>
                    </th>
                    <th>{{'customer-service.Global CC' |translate |translateKey }}
                        <span [ngClass]="{'fa-sort':(sortOption !== 'newChairmanCC' || sortOption !== 'newChairmanCC'),'fa-sort-desc':sortOption === 'newChairmanCC','fa-sort-asc':sortOption === 'newChairmanCC'}"
                            class="fa" id="sort" tabindex="0" (keyup.enter)="getDownlineDetailsBySortOption('newChairmanCC')" (click)="getDownlineDetailsBySortOption('newChairmanCC')">
                        </span>
                    </th>
                    <th>{{'customer-service.Phone' |translate |translateKey }}
                        <span [ngClass]="{'fa-sort':(sortOption !== 'phone' || sortOption !== 'phone'),'fa-sort-desc':sortOption === 'phone','fa-sort-asc':sortOption === 'phone'}"
                            class="fa" id="sort" tabindex="0" (keyup.enter)="getDownlineDetailsBySortOption('phone')" (click)="getDownlineDetailsBySortOption('phone')">
                        </span>
                    </th>
                    <th>{{'customer-service.Email' |translate |translateKey }}
                        <span [ngClass]="{'fa-sort':(sortOption !== 'email' || sortOption !== 'email'),'fa-sort-desc':sortOption === 'email','fa-sort-asc':sortOption === 'email'}"
                            class="fa" id="sort" tabindex="0" (keyup.enter)="getDownlineDetailsBySortOption('email')" (click)="getDownlineDetailsBySortOption('email')">
                        </span>
                    </th>
                </tr>
            </thead>
            <colgroup>
                <col style="width: 217px;">
                <col style="width: 90px;">
                <col style="width: 105px;">
                <col style="width: 160px;">
                <col style="width: 70px;">
                <col style="width: 160px;">
                <col style="width: 55px;">
                <col style="width: 55px;">
                <col style="width: 55px;">
                <col style="width: 55px;">
                <col style="width: 55px;">
                <col style="width: 58px;">
                <col style="width: 55px;">
                <col style="width: 55px;">
                <col style="width: 55px;">
                <col style="width: 55px;">
                <col style="width: 55px;">
                <col style="width: 55px;">
                <col style="width: 109px;">
                <col style="width: 55px;">
                <col style="width: 55px;">
                <col style="width: 55px;">
                <col style="width: 55px;">
                <col style="width: 55px;">
                <col style="width: 55px;">
                <col style="width: 55px;">
                <col style="width: 55px;">
                <col style="width: 55px;">
                <col style="width: 55px;">
                <col style="width: 55px;">
                <col style="width: 55px;">
                <col style="width: 150px;">
                <col style="width: 170px;">
                <col style="width: 114px;">
                <col style="width: 250px;">
            </colgroup>
            <tbody trow *ngFor="let detail of data" [(distributorLevel)]="distributorLevel" [country]="country" [rowItem]="detail"
            [level]="level" [(expandingLevel)]="expandingLevel" [(isOpen)]="isOpen" [class.display-type]="isOpen" id="header-scroll" >

            </tbody>
        </table>
    </div>
</div>
<div *ngIf="errormessage==true" id="errormessage">
    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{'common.Sorry, Something Went Wrong: Please try again later.' |translate |translateKey}}
</div>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/downline-report.component.html